import React, { ReactNode, createContext, useContext } from 'react';

import { useDynamicWhatsapp } from 'hooks/useDynamicWhatsapp';

interface SupportContextData {
  whatsappNumber: string | null;
  whatsappText: string | null;
  isLoading: boolean;
  error: Error | null;
}

interface SupportProviderProps {
  children: ReactNode;
}

const SupportContext = createContext<SupportContextData | undefined>(undefined);

export const SupportProvider: React.FC<SupportProviderProps> = ({ children }) => {
  const { whatsappNumber, whatsappText, isLoading, error } = useDynamicWhatsapp();

  return (
    <SupportContext.Provider
      value={{
        whatsappNumber,
        whatsappText,
        isLoading,
        error,
      }}
    >
      {children}
    </SupportContext.Provider>
  );
};

export const useSupport = (): SupportContextData => {
  const context = useContext(SupportContext);
  if (!context) {
    throw new Error('useSupport must be used within a SupportProvider');
  }
  return context;
};
